(function () {
  // -----------------------------
  // Header elements
  // -----------------------------
  const dropdownBtn = document.querySelector(".qld__uninav__item-toggle");
  const dropdownMenu = document.querySelector(".qld__uninav__menu-sub");
  const dropdownInner = document.querySelector(".qld__uninav__menu-sub-inner");
  const overlay = document.querySelector(".qld__main-nav__overlay");
  const searchForm = document.querySelector(
    ".qld__header__search .qld__search-form",
  );

  // Bail early if essential elements do not exist
  if (!dropdownBtn || !dropdownMenu || !dropdownInner || !overlay) {
    return;
  }

  let isOpen = false;
  let openedByKeyboard = false;

  let focusableEls = [];
  let firstFocusableEl;
  let lastFocusableEl;

  const openClass = "qld__uninav__accordion--open";
  const closedClass = "qld__uninav__accordion--closed";
  const overlayOpen = "qld__main-nav__overlay--open";
  const overlayClosed = "qld__main-nav__overlay--closed";

  // -----------------------------
  // Open menu
  // -----------------------------
  function openMenu() {
    isOpen = true;

    dropdownMenu.hidden = false;
    dropdownBtn.setAttribute("aria-expanded", "true");

    [dropdownBtn, dropdownMenu, overlay].forEach((el) => {
      el.classList.remove(closedClass);
      el.classList.add(openClass);
    });

    overlay.classList.remove(overlayClosed);
    overlay.classList.add(overlayOpen);

    // Set height for smooth animation
    dropdownMenu.style.height = dropdownMenu.scrollHeight + "px";

    // Get focusable elements inside menu
    focusableEls = dropdownMenu.querySelectorAll(
      'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );
    firstFocusableEl = focusableEls[0];
    lastFocusableEl = focusableEls[focusableEls.length - 1];

    // Move focus ONLY if opened via keyboard
    if (openedByKeyboard) {
      firstFocusableEl?.focus();
    }
    openedByKeyboard = false;

    // Listen for key events
    document.addEventListener("keydown", handleKeyDown);
  }

  // -----------------------------
  // Close menu
  // -----------------------------
  function closeMenu() {
    isOpen = false;

    dropdownMenu.hidden = true;
    dropdownBtn.setAttribute("aria-expanded", "false");

    [dropdownBtn, dropdownMenu, overlay].forEach((el) => {
      el.classList.remove(openClass);
      el.classList.add(closedClass);
    });
    overlay.classList.remove(overlayOpen);
    overlay.classList.add(overlayClosed);

    dropdownMenu.style.height = "0px";

    // Return focus to toggle button
    dropdownBtn.focus();

    document.removeEventListener("keydown", handleKeyDown);
  }

  // -----------------------------
  // Handle key events (Esc + focus trap)
  // -----------------------------
  function handleKeyDown(event) {
    if (!isOpen) return;

    switch (event.key) {
      case "Escape":
        closeMenu();
        break;

      case "Tab":
        // Trap focus inside menu
        if (focusableEls.length === 0) break;

        if (event.shiftKey) {
          // Shift + Tab
          if (document.activeElement === firstFocusableEl) {
            event.preventDefault();
            lastFocusableEl.focus();
          }
        } else {
          // Tab
          if (document.activeElement === lastFocusableEl) {
            event.preventDefault();
            firstFocusableEl.focus();
          }
        }
        break;

      default:
        break;
    }
  }

  // -----------------------------
  // Detect keyboard activation
  // -----------------------------
  dropdownBtn?.addEventListener("keydown", (event) => {
    if (event.key === "Enter" || event.key === " ") {
      openedByKeyboard = true;
    }
  });

  // -----------------------------
  // Event listeners
  // -----------------------------
  dropdownBtn?.addEventListener("click", (event) => {
    event.stopPropagation();
    isOpen ? closeMenu() : openMenu();
  });

  window.addEventListener("click", (event) => {
    if (
      isOpen &&
      !dropdownInner.contains(event.target) &&
      !dropdownBtn.contains(event.target)
    ) {
      closeMenu();
    }
  });

  // -----------------------------
  // Search form handling
  // -----------------------------
  if (searchForm) {
    const searchBtn = searchForm.querySelector(".qld__btn--search");
    searchBtn.setAttribute("type", "submit");

    searchForm
      .querySelectorAll(".qld__btn--search, .qld__text-input")
      .forEach((el) => {
        el.removeAttribute("disabled");
      });

    checkHoneypot();
  }

  function checkHoneypot() {
    const honeypot = searchForm.querySelector(".qld__text-input--validation");
    honeypot.value = "";

    searchForm.addEventListener("submit", function (event) {
      if (honeypot.value !== "") {
        event.preventDefault(); // Block spam
      } else {
        honeypot.removeAttribute("name"); // Allow submission
      }
    });
  }

  // Recalculate height on window resize
  window.addEventListener("resize", () => {
    if (
      dropdownMenu &&
      dropdownMenu.classList.contains("qld__uninav__accordion--open")
    ) {
      const contentHeight = dropdownMenu.scrollHeight;
      const maxAllowedHeight = window.innerHeight * 0.8;
      dropdownMenu.style.height =
        Math.min(contentHeight, maxAllowedHeight) + "px";
    }
  });
})();
